import request from '@/utils/request.js';

export function login(data) {
    return request({
        url: "/api/user.user/login",
        method: "post",
        data
    });
}

export function getUserInfo(){
  return request({
    url: "/api/user.index/detail",
    method: "get",
    
  });
}